import { render, staticRenderFns } from "./MessagesCopy.vue?vue&type=template&id=6e1c0c3a&scoped=true&"
import script from "./MessagesCopy.vue?vue&type=script&lang=js&"
export * from "./MessagesCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c0c3a",
  null
  
)

export default component.exports